import { TableCell as MuiTableCell } from "@mui/material"
import classNames from "classnames"
import { Column } from "./types"
import { safeToString } from "@/utils/index"

export interface CellProps<T> {
   id: string
   column: Column<T>
   row: T
   isEditing: boolean
   onInputChange: (field: keyof T, value: string) => void
   onBulkPaste?: (rows: string[]) => void
   value: T[keyof T]
   inputValue: T[keyof T] | undefined
   hasError?: boolean
   isDimmed?: boolean
}

export function Cell<T extends { id: number | string; draggable?: boolean }>({
   id,
   column,
   row,
   isEditing,
   onInputChange,
   value,
   hasError = false,
   isDimmed = false,
   onBulkPaste = () => {},
}: CellProps<T>) {
   const isColumnEditable = column.editable !== false
   const isEditingCell = isColumnEditable && isEditing
   const isColumnDimmable = column.dimmable !== false

   return (
      <MuiTableCell
         id={id}
         className={classNames("table__cell", {
            "table__cell--draggable": id === "drag-column" && row.draggable,
            "table__cell--dimmed": isColumnDimmable && isDimmed,
         })}
      >
         {column.renderCell ? (
            column.renderCell({
               value,
               row,
               isEditing: isEditingCell,
               onInputChange,
               onBulkPaste,
               hasError,
               cellTextTestId: column.cellTextTestId,
            })
         ) : (
            <div className="table__cell-content">
               <div
                  className="table__cell-text"
                  {...(column.cellTextTestId && {
                     "data-testid": column.cellTextTestId,
                  })}
               >
                  {safeToString(value)}
               </div>
            </div>
         )}
      </MuiTableCell>
   )
}
